import colors from "../theme";

export const formControlLabelSx = {
  width: { xs: "146px", md: "auto" },
  "& .MuiFormControlLabel-label": {
    fontSize: "15px",
    lineHeight: 2,
  },
  "& .MuiFormControlLabel-root": {
    margin: 0,
    padding: 0,
  },
  "& .MuiRadio-root": {
    padding: "0 5px 0 10px",
    color: colors.secondary,
    "&.Mui-checked": {
      color: colors.secondary,
    },
  },
};

export const formControlInputStyle = {
  "& .MuiInputLabel-root.Mui-focused": {
    color: colors.secondary,
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.secondary,
  },
};
